import { useMemo } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { useAuth } from '@/auth/hooks/useAuth';
import { TaskListPage } from './TaskListPage';
import { TaskDetailPage } from './TaskDetailPage';
import { AdminDashboardPage } from './AdminDashboardPage';
import { AdminTaskListPage } from './AdminTaskListPage';
import { AdminCreateTaskPage } from './AdminCreateTaskPage';
import { AdminUserTaskStatusesPage } from './AdminUserTaskStatusesPage';

export function LitLegionArchePage() {
  const { user } = useAuth();
  const isAdmin = useMemo(
    () =>
      (user?.roles?.includes('admin') ?? false) ||
      (user?.roles?.includes('litcraft_admin') ?? false),
    [user?.roles],
  );

  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<TaskListPage />} />
        <Route path="/tasks/:taskId" element={<TaskDetailPage />} />
        <Route
          path="/admin"
          element={isAdmin ? <AdminDashboardPage /> : <Navigate to="/" replace />}
        />
        <Route
          path="/admin/tasks"
          element={isAdmin ? <AdminTaskListPage /> : <Navigate to="/" replace />}
        />
        <Route
          path="/admin/tasks/create"
          element={isAdmin ? <AdminCreateTaskPage /> : <Navigate to="/" replace />}
        />
        <Route
          path="/admin/user-statuses"
          element={isAdmin ? <AdminUserTaskStatusesPage /> : <Navigate to="/" replace />}
        />
      </Routes>
    </ArcheLayout>
  );
}
